// extracted by mini-css-extract-plugin
export var alignRight = "Badge-module--alignRight--a5d8c";
export var container = "Badge-module--container--65b4a";
export var vertical = "Badge-module--vertical--375e7";